export default "__VITE_ASSET__DZO1xeFc__"